import { types } from 'mobx-state-tree';

import AddressSummary from './AddressSummary';

export default types.model('OrderOffer', {
  uid: types.string,
  buyer: types.string,
  item_price: types.number,
  shipping: types.string,
  requires_dropoff: types.boolean,
  delivery: AddressSummary,
  alias: types.optional(types.string, ''),
});
